import { Link } from 'react-router-dom'
import { LucideIcon, ArrowUpRight } from 'lucide-react'
import { useLocalePath } from '../../hooks/useLocalePath'
import styles from './ServiceCard.module.css'

interface ServiceCardProps {
  title: string
  description: string
  icon: LucideIcon
  slug: string
}

export default function ServiceCard({ title, description, icon: Icon, slug }: ServiceCardProps) {
  const lp = useLocalePath()

  return (
    <Link to={lp(`/services/${slug}`)} className={styles.card}>
      <div className={styles.cardInner}>
        <div className={styles.iconWrap}>
          <Icon size={22} strokeWidth={1.8} />
        </div>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{description}</p>
        <span className={styles.link}>
          Learn more <ArrowUpRight size={14} />
        </span>
      </div>
      <div className={styles.cardShine} />
    </Link>
  )
}
